// @ts-check
import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import PreConstruction from './PreConstruction'
import Construction from './Construction'
import SoftCosts from './SoftCosts'
import Box from '@material-ui/core/Box';
import useFormStyles from '../../common/FormStyle';
import Button from '@material-ui/core/Button';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { GoToPlootoButton } from '../common/GoToPlootoButton'
import { useDispatch, useSelector } from 'react-redux';
import {
  SET_ACTIVE_TAB, SET_CURRENCY
} from '../../../redux/actions/actionTypes';
import SimpleTextInput from '../common/SimpleTextInput';

const useStyles = makeStyles((heme) => ({
  root: {
    minHeight: "100vh",
  }
}))

// Form section 1 component
function FormCosts(props) {
  const { handleNext } = props;
  const dispatch = useDispatch()
  const styles = useStyles();
  const formStyles = useFormStyles();

  const state = useSelector(state => state);

  return (
    <>
      <Box paddingX={2} paddingY={2} className={styles.root}
        display="flex" flexDirection="column">

        <Typography variant="h5" className={formStyles.bold}>Costs</Typography>
        <SimpleTextInput label="Currancy" name="currancy" type="text"
          value={state.globalFormData.costs.currency}
          onChange={(event) => {
            // setcurrancy(event.target.value)
            dispatch({
              type: SET_CURRENCY,
              payload: event.target.value
            })
            console.log(state)
          }}
        />



        <Box paddingY={2}>
          <PreConstruction />
          <Construction />
          <SoftCosts />
        </Box>

        <GoToPlootoButton />

        <Box marginY={1}>
          <Button
            variant="contained"
            endIcon={<NavigateNextIcon />}
            fullWidth
            onClick={(event) => {
              dispatch({
                type: SET_ACTIVE_TAB,
                payload: 2
              })
            }}>
            Next
          </Button>
        </Box>
      </Box>
    </>
  )
}

export default FormCosts